import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export default function MangakuHero() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    const t = setTimeout(() => {
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[640px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/dede8ef450494cae54582370f9d3bef2.jpg"
        alt="まんがく カードショップ 高松"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/25"></div>

      <div ref={scrollRef} className="relative z-10 flex flex-col justify-center h-full px-8 md:px-16 lg:px-24 max-w-5xl">
        <div className="mb-4">
          <Link to="/" className="inline-flex items-center gap-2 text-white/50 text-xs tracking-widest uppercase hover:text-white/80 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line text-xs"></i>
            株式会社BotaN
          </Link>
        </div>
        <p className="text-xs tracking-[0.4em] text-red-300/80 uppercase mb-5 font-sans">
          Mangaku — カードショップ 高松
        </p>
        <h1 className="text-5xl md:text-7xl font-serif font-semibold text-white leading-tight mb-6">
          高松の<span className="text-red-200">カード聖地</span>、<br />
          まんがく。
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-xl leading-relaxed mb-10 font-sans font-light">
          香川県高松市のトレーディングカード専門店。<br />
          <strong className="text-white/90 font-medium">ポケモンカード・ワンピースカード</strong>をはじめ、<br />
          人気TCGの買取・販売を行っています。
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://lin.ee/OGQq9z6"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-[#06C755] text-white px-8 py-4 rounded-full text-sm font-medium whitespace-nowrap hover:bg-[#05b34c] transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-line-fill text-sm"></i>
            </div>
            LINEで買取相談
          </a>
          <a
            href="https://www.google.com/maps?q=香川県高松市瓦町2-1-28"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border border-white/50 text-white px-8 py-4 rounded-full text-sm font-medium whitespace-nowrap hover:bg-white/10 transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-map-pin-line text-xs"></i>
            </div>
            店舗へのアクセス
          </a>
        </div>
        <div className="mt-10 flex items-center gap-6">
          <div className="flex flex-col">
            <span className="text-2xl font-serif font-semibold text-red-200">5+</span>
            <span className="text-xs text-white/50 mt-0.5">取扱TCG</span>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="flex flex-col">
            <span className="text-2xl font-serif font-semibold text-red-200">買取</span>
            <span className="text-xs text-white/50 mt-0.5">販売も対応</span>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="flex flex-col">
            <span className="text-2xl font-serif font-semibold text-red-200">高松</span>
            <span className="text-xs text-white/50 mt-0.5">瓦町エリア</span>
          </div>
        </div>
      </div>
    </section>
  );
}
